import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Navbar, Nav, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { FiLogOut, FiPhoneCall } from "react-icons/fi";
import { Link as ReactRouterLink } from "react-router-dom";
import { RegistererState } from "sip.js";
import {
  Popover,
  IconButton,
  Box,
  Typography,
  Badge,
  ListItemText,
  ListItem,
  List,
  Tabs,
  Tab,
  Link,
  Tooltip,
} from "@mui/material";
import DialpadIcon from "@mui/icons-material/Dialpad";
import NotificationsIcon from "@mui/icons-material/Notifications";
import PhoneIcon from "@mui/icons-material/Phone";
import SearchIcon from "@mui/icons-material/Search";
import apiClient from "../../services/apiClient";

import { useSIP } from "../../hooks/calls/useSIP";
import {
  clearUser,
  setUserDetails,
  updateUserDetails,
} from "../../features/user/UserSlice";
import { setModal, setSubModal } from "../../features/modal/ModalSlice";
import { removeSipConfig } from "../../features/SIP/SIPConfigSlice";
import CustomInputBox from "../Form/CustomInputBox";
import CustomButton from "../Button/CustomButton";

const Header = () => {
  const [notificationAnchorEl, setNotificationAnchorEl] = useState(null);
  const [phoneAnchorEl, setPhoneAnchorEl] = useState(null);
  const [selectedTab, setSelectedTab] = useState(0);
  const [pending, setPending] = useState([]);
  const [approved, setApproved] = useState([]);

  const notificationOpen = Boolean(notificationAnchorEl);
  const phoneOpen = Boolean(phoneAnchorEl);

  const notificationPopoverId = notificationOpen
    ? "notification-popover"
    : undefined;
  const phonePopoverId = phoneOpen ? "phone-popover" : undefined;
  const tabContent = selectedTab === 0 ? pending : approved;

  const { regState } = useSelector((state) => state.SIPCalls);
  const SIPConfig = useSelector((state) => state.SIPConfig);
  const userInfo = useSelector((state) => state.userInfo.user);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { connectSIP, disconnectSIP } = useSIP();

  useEffect(() => {
    fetchDetails();
    // if (userInfo?.settings?.auto_connect && SIPConfig?.sipUsername)
    //   handleConnect();
    // }

    if (userInfo?.role === "2") fetchRequests();
  }, []);

  const fetchRequests = async () => {
    try {
      const response = await apiClient.get(
        `/requests/user?user_id=${userInfo?.id}`
      );

      // Categorize data into pending and approved
      const data = response?.data || [];
      const pendingRequests = data.filter(
        (item) =>
          item?.request_status === "pending" ||
          item?.request_status === "Pending"
      );
      const approvedRequests = data.filter(
        (item) => item?.request_status === "approved"
      );

      setPending(pendingRequests);
      setApproved(approvedRequests);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchDetails = async () => {
    try {
      const response = await apiClient.get(`/user/${userInfo?.id}`);

      const extension = response?.data?.user?.settings?.default_extension;
      dispatch(updateUserDetails(response?.data?.user));

      if (!extension?.extension) return;
      const SipConfig = {
        sipUsername: extension?.extension,
        sipPassword: extension?.password,
        sipServer: userInfo?.company_domain,
        webSocketUrl: process.env.REACT_APP_VOIP_WEBSOCKET_BASE_URL,
      };

      connectSIP(SipConfig);
    } catch (err) {
      console.log(err);
    }
  };

  const handleConnect = () => {
    const SipConfig = {
      sipUsername: SIPConfig?.sipUsername,
      sipPassword: SIPConfig?.sipPassword,
      sipServer: userInfo?.company_domain,
      webSocketUrl: process.env.REACT_APP_VOIP_WEBSOCKET_BASE_URL,
    };

    connectSIP(SipConfig);
  };

  const handleDisconnect = () => {
    disconnectSIP();
  };

  const handleLogout = () => {
    dispatch(clearUser());
    dispatch(removeSipConfig());
    navigate("/");
  };

  const handleLoginPopUp = () => {
    dispatch(setModal({ type: "LOGIN" }));
  };

  const handleSignupPopUp = () => {
    dispatch(setModal({ type: "SIGNUP" }));
  };

  const handleDialCall = () => {
    handlePhonePopoverClose();
    dispatch(setModal({ type: "CALL_DIALPAD" }));
  };

  const handleNotificationClick = (event) => {
    setNotificationAnchorEl(event.currentTarget);
  };

  const handlePhoneClick = (event) => {
    setPhoneAnchorEl(event.currentTarget);
  };

  const handleNotificationPopoverClose = () => {
    setNotificationAnchorEl(null);
  };

  const handlePhonePopoverClose = () => {
    setPhoneAnchorEl(null);
  };

  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const handleOutBoundCall = () => {
    // dispatch(setSubModal({ type: "OUTBOUND" }));
    dispatch(setSubModal({ type: "COMMONCALL" }));
  };

  return (
    <Navbar expand="lg" className="custom-navbar">
      <Container>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse
          id="basic-navbar-nav"
          className="justify-content-between"
        >
          <CustomInputBox
            icon={SearchIcon}
            placeholder="Search Calls, recordings"
            type="text"
            width={"50%"}
          />

          <Nav>
            {userInfo ? (
              <>
                <Box className="mx-3">
                  {userInfo?.role === "2" && (
                    <>
                      <Tooltip title="Notification">
                        <Badge
                          variant="dot"
                          overlap="circular"
                          anchorOrigin={{
                            vertical: "top",
                            horizontal: "right",
                          }}
                        >
                          <IconButton
                            color="primary"
                            onClick={handleNotificationClick}
                          >
                            <NotificationsIcon />
                          </IconButton>
                        </Badge>
                      </Tooltip>

                      <Popover
                        id={notificationPopoverId}
                        open={notificationOpen}
                        anchorEl={notificationAnchorEl}
                        onClose={handleNotificationPopoverClose}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                        sx={{
                          "& .MuiPopover-paper": {
                            borderRadius: "16px",
                          },
                        }}
                      >
                        <Box
                          sx={{
                            padding: 2,
                            minWidth: 200,
                            maxHeight: 300,
                            display: "flex",
                            flexDirection: "column",
                            overflow: "hidden",
                          }}
                        >
                          {/* Tabs */}
                          <Tabs
                            value={selectedTab}
                            onChange={handleChange}
                            variant="fullWidth"
                            sx={{
                              borderBottom: 1,
                              borderColor: "divider",
                            }}
                          >
                            <Tab label="Pending" />
                            <Tab label="Approved" />
                          </Tabs>

                          {/* Tab Content */}
                          <Box
                            sx={{
                              flex: 1,
                              overflowY: "auto",
                              marginTop: 1,
                            }}
                          >
                            <List>
                              {tabContent.map((item) => (
                                <ListItem key={item.id}>
                                  <ListItemText
                                    sx={{
                                      width: "50px",
                                    }}
                                    primary={
                                      selectedTab === 1 // Approved Tab
                                        ? `Your request of ${
                                            item.no_of_phones_required
                                          } phone number on  ${new Date(
                                            item.created_at
                                          )} has been approved.`
                                        : `Your request of ${
                                            item.no_of_phones_required
                                          } phone number on ${new Date(
                                            item.created_at
                                          )} is pending.`
                                    }
                                    primaryTypographyProps={{
                                      fontSize: "0.9rem",
                                      // color: selectedTab === 1 ? "green" : "orange",
                                    }}
                                  />
                                </ListItem>
                              ))}
                            </List>
                          </Box>
                        </Box>
                      </Popover>
                    </>
                  )}
                  {/* {userInfo?.role === "3" && (
                    <>
                      <Tooltip title="call">
                        <Badge
                          color={
                            regState === RegistererState.Registered
                              ? "success"
                              : "error"
                          }
                          variant="dot"
                          overlap="circular"
                          anchorOrigin={{
                            vertical: "top",
                            horizontal: "right",
                          }}
                        >
                          <IconButton
                            color="primary"
                            onClick={handlePhoneClick}
                          >
                            <PhoneIcon />
                          </IconButton>
                        </Badge>
                      </Tooltip>

                      <Tooltip title="Inbound Call">
                        <Badge
                          color={
                            regState === RegistererState.Registered
                              ? "success"
                              : "error"
                          }
                          variant="dot"
                          overlap="circular"
                          anchorOrigin={{
                            vertical: "top",
                            horizontal: "right",
                          }}
                        >
                          <Button
                            onClick={handlePhoneClick}
                            sx={{
                              backgroundColor: "#5C4EF5", // purple
                              color: "#fff",
                              textTransform: "none",
                              fontWeight: "bold",
                              borderRadius: "12px",
                              padding: "8px 16px",
                              "&:hover": {
                                backgroundColor: "#4838D1",
                              },
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            InBound Call
                            <PhoneIcon sx={{ fontSize: 20 }} />
                          </Button>
                        </Badge>
                      </Tooltip>

                      <Popover
                        id={phonePopoverId}
                        open={phoneOpen}
                        anchorEl={phoneAnchorEl}
                        onClose={handlePhonePopoverClose}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                        sx={{
                          "& .MuiPopover-paper": {
                            borderRadius: "16px",
                          },
                        }}
                      >
                        {SIPConfig?.sipUsername ? (
                          <Box
                            sx={{
                              padding: 2,
                              minWidth: 200,
                              alignItems: "center",
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <Typography variant="h6" gutterBottom>
                              {regState === RegistererState.Registered
                                ? "Connected"
                                : "Connect To Extension"}
                            </Typography>

                            <Typography
                              variant="body2"
                              color="text.secondary"
                              sx={{ mb: 2 }}
                            >
                              {regState === RegistererState.Registered
                                ? `Connected To ${SIPConfig?.sipUsername} extension`
                                : `To start a call from the ${SIPConfig?.sipUsername} register first.`}
                            </Typography>

                            {regState === RegistererState.Registered ? (
                              <div className="d-flex">
                                <CustomButton
                                  variant="contained"
                                  color="primary"
                                  icon={<DialpadIcon />}
                                  iconPosition="left"
                                  fullWidth
                                  onClick={handleDialCall}
                                  className="mx-2"
                                >
                                  Call
                                </CustomButton>
                                <CustomButton
                                  variant="outlined"
                                  color="primary"
                                  fullWidth
                                  onClick={handleDisconnect}
                                >
                                  Disconnect
                                </CustomButton>
                              </div>
                            ) : (
                              <CustomButton
                                variant="contained"
                                color="primary"
                                fullWidth
                                onClick={handleConnect}
                                sx={{ mb: 1 }}
                              >
                                Connect
                              </CustomButton>
                            )}
                          </Box>
                        ) : (
                          <Box
                            sx={{
                              padding: 2,
                              minWidth: 200,
                              alignItems: "center",
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <Typography variant="h6" gutterBottom>
                              No extension
                            </Typography>

                            <Typography
                              variant="body2"
                              color="text.secondary"
                              sx={{ mb: 2 }}
                            >
                              You don't have any{" "}
                              <Link
                                component={ReactRouterLink}
                                to={"/extensions"}
                                underline="hover"
                              >
                                extension
                              </Link>{" "}
                              assigned.
                            </Typography>

                            <Typography
                              variant="body2"
                              color="text.secondary"
                              sx={{ mb: 2 }}
                            >
                              Contact Your Admin
                            </Typography>
                          </Box>
                        )}
                      </Popover>
                    </>
                  )} */}
                </Box>

                <div className="d-flex justify-content-between align-items-center mt-3 gap-3">
                  {/* <CustomButton
                    text={"InBound Call"}
                    iconPosition="right"
                    icon={<FiPhoneCall />}
                    onClick={handleOutBoundCall}
                    className="me-3"
                  /> */}

                  {userInfo?.role === "3" && (
                    <>
                      <Tooltip title="Inbound Call">
                        <Badge
                          color={
                            regState === RegistererState.Registered
                              ? "success"
                              : "error"
                          }
                          variant="dot"
                          overlap="circular"
                          anchorOrigin={{
                            vertical: "top",
                            horizontal: "right",
                          }}
                        >
                          <Button
                            onClick={handlePhoneClick}
                            sx={{
                              backgroundColor: "#5C4EF5", // purple
                              color: "#fff",
                              textTransform: "none",
                              fontWeight: "bold",
                              borderRadius: "12px",
                              padding: "8px 16px",
                              "&:hover": {
                                backgroundColor: "#4838D1",
                              },
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            Inbound Call
                            <PhoneIcon sx={{ fontSize: 20 }} />
                          </Button>
                        </Badge>
                      </Tooltip>

                      <Popover
                        id={phonePopoverId}
                        open={phoneOpen}
                        anchorEl={phoneAnchorEl}
                        onClose={handlePhonePopoverClose}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                        sx={{
                          "& .MuiPopover-paper": {
                            borderRadius: "16px",
                          },
                        }}
                      >
                        {SIPConfig?.sipUsername ? (
                          <Box
                            sx={{
                              padding: 2,
                              minWidth: 200,
                              alignItems: "center",
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <Typography variant="h6" gutterBottom>
                              {regState === RegistererState.Registered
                                ? "Connected"
                                : "Connect To Extension"}
                            </Typography>

                            <Typography
                              variant="body2"
                              color="text.secondary"
                              sx={{ mb: 2 }}
                            >
                              {regState === RegistererState.Registered
                                ? `Connected To ${SIPConfig?.sipUsername} extension`
                                : `To start a call from the ${SIPConfig?.sipUsername} register first.`}
                            </Typography>

                            {regState === RegistererState.Registered ? (
                              <div className="d-flex">
                                <CustomButton
                                  variant="contained"
                                  color="primary"
                                  icon={<DialpadIcon />}
                                  iconPosition="left"
                                  fullWidth
                                  onClick={handleDialCall}
                                  className="mx-2"
                                >
                                  Call
                                </CustomButton>
                                <CustomButton
                                  variant="outlined"
                                  color="primary"
                                  fullWidth
                                  onClick={handleDisconnect}
                                >
                                  Disconnect
                                </CustomButton>
                              </div>
                            ) : (
                              <CustomButton
                                variant="contained"
                                color="primary"
                                fullWidth
                                onClick={handleConnect}
                                sx={{ mb: 1 }}
                              >
                                Connect
                              </CustomButton>
                            )}
                          </Box>
                        ) : (
                          <Box
                            sx={{
                              padding: 2,
                              minWidth: 200,
                              alignItems: "center",
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <Typography variant="h6" gutterBottom>
                              No extension
                            </Typography>

                            <Typography
                              variant="body2"
                              color="text.secondary"
                              sx={{ mb: 2 }}
                            >
                              You don't have any{" "}
                              <Link
                                component={ReactRouterLink}
                                to={"/extensions"}
                                underline="hover"
                              >
                                extension
                              </Link>{" "}
                              assigned.
                            </Typography>

                            <Typography
                              variant="body2"
                              color="text.secondary"
                              sx={{ mb: 2 }}
                            >
                              Contact Your Admin
                            </Typography>
                          </Box>
                        )}
                      </Popover>
                    </>
                  )}

                  {/* <CustomButton
                    text={"Outbound Call"}
                    iconPosition="right"
                    icon={<FiPhoneCall />}
                    onClick={handleOutBoundCall}
                    className="me-3"
                  /> */}

                  <Tooltip title="Outbound Call">
                    <Button
                      onClick={handleOutBoundCall}
                      sx={{
                        backgroundColor: "#007BFF",
                        textTransform: "none",
                        fontWeight: "bold",
                        borderRadius: "12px",
                        padding: "8px 16px",
                        "&:hover": {
                          backgroundColor: "#0069d9",
                        },
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      Outbound Call
                      <PhoneIcon sx={{ fontSize: 20 }} />
                    </Button>
                  </Tooltip>

                  <CustomButton
                    text={"Logout"}
                    iconPosition="right"
                    icon={<FiLogOut />} // ✅ Keep icon only for Logout
                    onClick={handleLogout}
                  />
                </div>
              </>
            ) : (
              <>
                <CustomButton
                  text={"Login"}
                  onClick={handleLoginPopUp}
                  variant="text"
                />

                <CustomButton
                  text={"Sign Up"}
                  onClick={handleSignupPopUp}
                  variant="outlined"
                />
              </>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
